/**
 * Forwards Locally SwitchLive widget events into Mixpanel.
 * Event ids: https://hub.locally.com/reference/live-event-model-reference
 */

(function () {
  'use strict';

  var DEBUG = /[?&]locally_debug=1/.test(window.location.search);
  var MAX_PENDING = 60;
  var PENDING_GIVE_UP_MS = 180000;
  var BROWSE_BATCH_MS = 1500;
  var BROWSE_BATCH_MAX_MS = 5000;
  var BROWSE_UPC_CAP = 20;

  var EVENT_NAMES = {
    1: 'Locally Widget Viewed V.1',
    4: 'Locally Store Link Clicked V.1',
    5: 'Locally Location Changed V.1',
    6: 'Locally All Options Clicked V.1',
    7: 'Locally Locator Opened V.1',
    9: 'Locally Store Link Clicked V.1',
    46: 'Locally Call Store Clicked V.1',
    56: 'Locally Store Locator Loaded V.1',
    59: 'Locally Browse Inventory Clicked V.1',
    61: 'Locally Browse Inventory Viewed V.1',
    63: 'Locally Product Thumb Clicked V.1',
    66: 'Locally Product Viewed V.1',
    68: 'Locally Buy Now Clicked V.1',
    71: 'Locally ROPIS Clicked V.1',
    73: 'Locally Call Store Clicked V.1',
    77: 'Locally Store Link Clicked V.1',
    80: 'Locally Added To Cart V.1',
    82: 'Locally Added To Cart V.1',
    83: 'Locally Order Placed V.1',
    84: 'Locally Order Placed V.1',
    86: 'Locally Buy Now Clicked V.1',
    89: 'Locally Buy Online Clicked V.1',
    91: 'Locally Buy Now Clicked V.1',
    92: 'Locally Directions Clicked V.1',
    93: 'Locally Call Store Clicked V.1',
    94: 'Locally Store Website Clicked V.1',
    95: 'Locally Store Page Clicked V.1',
    96: 'Locally Buy Now Clicked V.1',
  };

  // 75, 87, 88, 90 and 103 are per-tile impressions — dozens per browse. Left unmapped on purpose.
  var AGGREGATED_IDS = { 61: true };

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ['[locally]'].concat([].slice.call(arguments)));
  }

  // switchlive.js binds to data-switchlive elements in this page, so its events post from our
  // own origin; only the modal's events come from Locally's frame. Both are accepted.
  function isTrustedOrigin(origin) {
    if (origin === window.location.origin) return true;

    var host;
    try {
      host = new URL(origin).host;
    } catch (e) {
      return false;
    }
    return /(^|\.)locally\.com$/.test(host);
  }

  function getShopifyProduct() {
    var result = { product_id: null, variant_id: null, sku: null };

    var scriptEl = document.querySelector('script[id^="ProductData-"]');
    if (scriptEl) {
      try {
        var data = JSON.parse(scriptEl.textContent);
        result.product_id = data.product_id ? String(data.product_id) : null;
        result.variant_id = data.variant_id ? String(data.variant_id) : null;
        result.sku = data.sku || null;
      } catch (e) {
        /* ignore */
      }
    }

    var variantEl = document.querySelector('script[data-selected-variant]');
    if (variantEl) {
      try {
        var variant = JSON.parse(variantEl.textContent);
        if (variant && variant.id) result.variant_id = String(variant.id);
        if (variant && variant.sku) result.sku = variant.sku;
      } catch (e) {
        /* ignore */
      }
    }

    return result;
  }

  function baseProps(data) {
    var props = {
      'Locally Event ID': data.id,
      'Locally Scope': data.scope || '',
      'Locally Description': data.description || '',
      'Interaction Type': data.type || '',
      'Page Type': (window.Shopify && window.Shopify.template_name) || '',
      'Current URL': window.location.href || '',
      'Page Title': document.title || '',
    };

    if (data.store_id) props['Store ID'] = String(data.store_id);
    if (data.store_name) props['Store Name'] = data.store_name;
    if (data.store_address) props['Store Address'] = data.store_address;
    if (data.sale_type) props['Sale Type'] = data.sale_type;
    if (data.vendor_id) props['Locally Vendor ID'] = String(data.vendor_id);
    if (data.locale_code) props['Locale Code'] = data.locale_code;
    if (data.upc) props['UPC'] = data.upc;

    // Locally's own catalogue id, not the Shopify product id — keep the names apart.
    if (data.product_id) props['Locally Product ID'] = String(data.product_id);

    // -1 is Locally's "no price available" sentinel, and prices arrive as strings that may
    // carry separators — parseFloat('1,299.00') would otherwise report a price of 1.
    var price = parseFloat(String(data.product_price == null ? '' : data.product_price).replace(/[^0-9.-]/g, ''));
    if (isFinite(price) && price > 0) {
      props['Product Price'] = price;
      props['Shop Currency'] = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    }

    // Modal events are about other dealers' products, so these name the host page only.
    var shopify = getShopifyProduct();
    if (shopify.product_id) props['Host Product ID'] = shopify.product_id;
    if (shopify.variant_id) props['Host Variant ID'] = shopify.variant_id;
    if (shopify.sku) props['Host SKU'] = shopify.sku;

    return props;
  }

  var pending = [];
  var pendingTimer = null;
  var pendingWaited = 0;
  var unloading = false;

  function mixpanelReady() {
    return typeof window.mixpanel !== 'undefined' && window.mixpanel.__loaded === true;
  }

  function flushPending() {
    while (pending.length) {
      var queued = pending.shift();
      try {
        window.mixpanel.track(queued[0], queued[1]);
      } catch (e) {
        /* a failed send must never stall the rest of the queue */
      }
    }
  }

  function watchForMixpanel() {
    if (pendingTimer) return;

    pendingWaited = 0;
    pendingTimer = setInterval(function () {
      pendingWaited += 1000;

      if (mixpanelReady()) {
        clearInterval(pendingTimer);
        pendingTimer = null;
        log('mixpanel ready, flushing', pending.length);
        flushPending();
        return;
      }

      // Mixpanel only loads behind OneTrust C0002. No consent in the window = drop, never send.
      if (pendingWaited >= PENDING_GIVE_UP_MS) {
        clearInterval(pendingTimer);
        pendingTimer = null;
        pending.length = 0;
        log('no analytics consent, discarded buffered events');
      }
    }, 1000);
  }

  function send(name, props) {
    log('track', name, props);

    if (mixpanelReady()) {
      try {
        if (unloading) {
          window.mixpanel.track(name, props, { transport: 'sendBeacon', send_immediately: true });
        } else {
          window.mixpanel.track(name, props);
        }
      } catch (e) {
        /* tracking must never break the widget */
      }
      return;
    }

    if (pending.length < MAX_PENDING) pending.push([name, props]);
    watchForMixpanel();
  }

  var browseBatch = null;

  function flushBrowseBatch() {
    if (!browseBatch) return;

    var batch = browseBatch;
    browseBatch = null;

    var props = baseProps(batch.data);
    props['Product Count'] = batch.count;
    if (batch.upcs.length) props['UPCs'] = batch.upcs;
    delete props['UPC'];
    delete props['Locally Product ID'];

    send(EVENT_NAMES[61], props);
  }

  function addBrowseImpression(data) {
    if (!browseBatch) browseBatch = { count: 0, upcs: [], data: data, timer: null, startedAt: Date.now() };

    browseBatch.count += 1;
    if (data.upc && browseBatch.upcs.indexOf(data.upc) === -1 && browseBatch.upcs.length < BROWSE_UPC_CAP) {
      browseBatch.upcs.push(data.upc);
    }

    // Lazy-loading tiles can re-arm the debounce indefinitely, so cap the wait.
    if (Date.now() - browseBatch.startedAt >= BROWSE_BATCH_MAX_MS) {
      flushBrowseBatch();
      return;
    }

    clearTimeout(browseBatch.timer);
    browseBatch.timer = setTimeout(flushBrowseBatch, BROWSE_BATCH_MS);
  }

  function flushBeforeUnload() {
    unloading = true;
    flushBrowseBatch();
    if (mixpanelReady()) flushPending();
  }

  window.addEventListener('pagehide', flushBeforeUnload);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flushBeforeUnload();
  });

  // lcly_reload_0 re-emits these on every variant change; the rest of the impression ids
  // (cart adds, modal opens, product views) are real repeats and must pass through.
  var ONCE_PER_PAGE_IDS = { 1: true, 56: true };
  var sentOnce = {};

  function isRepeat(data) {
    if (!ONCE_PER_PAGE_IDS[data.id]) return false;
    if (sentOnce[data.id]) return true;

    sentOnce[data.id] = true;
    return false;
  }

  function handle(origin, data) {
    if (!isTrustedOrigin(origin)) {
      log('rejected origin', origin);
      return;
    }

    if (!data || typeof data.id === 'undefined') return;

    var name = EVENT_NAMES[data.id];
    if (!name) {
      log('unmapped event', data.id, data.scope, data.description);
      return;
    }

    if (AGGREGATED_IDS[data.id]) {
      addBrowseImpression(data);
      return;
    }

    if (isRepeat(data)) {
      log('already sent this page', data.id);
      return;
    }

    send(name, baseProps(data));
  }

  var bridge = window.__gibsonSwitchLive;
  if (!bridge || !Array.isArray(bridge.queue)) {
    bridge = window.__gibsonSwitchLive = { queue: [], handler: null };
    window.addEventListener('message', function (e) {
      if (!e.data || e.data.message_type !== 'switchlive') return;
      if (bridge.handler) {
        bridge.handler(e.origin, e.data);
        return;
      }
      if (bridge.queue.length < 100) bridge.queue.push([e.origin, e.data]);
    });
  }

  bridge.handler = handle;

  while (bridge.queue.length) {
    var buffered = bridge.queue.shift();
    handle(buffered[0], buffered[1]);
  }
})();
